<div class="menu__list">
  @for (menuItem of menuData.items; track $index) {
    @if (!(menuItem.hidden && menuItem.hidden(menuData.context))) {
      <div
        class="menu-item"
        [ngClass]="{
          danger: menuItem.variant === 'danger',
          success: menuItem.variant === 'success',
          disabled: menuItem.disabled && menuItem.disabled(menuData.context),
        }"
        (click)="onMenuItemClick(menuItem)"
      >
        @if (menuItem.icon) {
          <svg
            class="menu-item__icon"
            [icon]="menuItem.icon"
          />
        }
        <span>{{ menuItem.label }}</span>
      </div>

      @if (!!menuItem?.separator) {
        <span class="menu-item__separator"></span>
      }
    }
  }
</div>
